import React from 'react';
import {withRouter} from 'react-router-dom';

import {AppContext} from '../../AppModule/Context';
import {withWidgetContext} from '../../components/widgetComponent/widgetContextProvider';

import HandOffComponent from '../../components/widgetComponent/openWidgetComponent/handOffComponent';
import PreloadLazyComponents from '../../components/common/genericComponents/preloadLazyComponents';
import MultiExpertWidget from '../../components/widgetComponent/MultiExpertWidget/multiExpertWidget';
import NotificationComponent from '../../components/common/genericComponents/notificationComponent';
import UpdateMarketingParamsComponent from '../../components/common/updateMarketingParamsComponent/updateMarketingParamsComponent';
import WindowResizerComponent from '../../components/widgetComponent/windowResizerComponent/windowResizerComponent';

import chatService from '../../services/chatService';
import postMessageService from '../../services/postMessageService';
import multiWidgetService from '../../services/multiWidgetService';
import utilsService from '../../services/utilsService';
import WidgetService from '../../services/restServices/widgetService';

import VIDABOO_CONSTANTS from '../../config/consts';

import './WidgetContainerComponent.css';

class WidgetContainerComponent extends React.Component {
  // responsible for loading data (mentorDto, sessionTemplateDto, image...); communicating with iframeApp; controling widget size;
  constructor() {
    super();
    this.state = {
      widgetInstalledMarketingParams: false,
      marketingParams: {},
      profileName: null,
      isDirectory: false,
      isAutomatedCallHandled: false,
      inTeamChatScenario: null,
      currentlyActiveMentorId: null, // this will have the id of mentor who is opened in teamChatScenario for any reason like action clicks, task owner of private room ...
      exMentorDtoOfChatTransition: null,
    };
    console.debug(
      '%c Consolto.com is running.',
      'color:#2961FA;background-color: white;font-weight:bold;padding:4px 6px 4px 0;border-radius:2px;',
    );
  }
  componentDidMount() {
    const [profileName, widgetId, isDirectory] = this.analyzeQueryParams();
    this.setState({isDirectory});
    this.getWidgetDto(profileName, widgetId);
  }

  analyzeQueryParams = () => {
    // Get booking flow instance token with query param named as bfi
    const allParams = new URLSearchParams(this.props.location.search);
    let bfi = allParams.get('bfi');
    this.setState({bfi});
    if (!bfi) {
      // Get from query string, To perform action by widget on personal page (Automated calls)
      this.setState({startValueFromQuery: allParams.get('start')});
    }
    let profileName = null;
    let pathName = this.props.location.pathname;
    let isDirectory = false;
    let widgetId = null;
    if (pathName.includes('expertWidget/wid/') > 0) {
      widgetId = pathName.split('/')[3];
    } else if (pathName.includes('/expert/') > 0) {
      profileName = pathName.split('/')[2];
      profileName = profileName?.toLowerCase();
    } else if (pathName.includes('expertDir/wid/')) {
      widgetId = pathName.split('/')[3];
      isDirectory = true;
    } else {
      // profileName = params.mentorProfileName; // pathName.split("/")[3];
      profileName = pathName.split('/')[2];
    }
    return [profileName, widgetId, isDirectory];
  };
  getWidgetDto = (profileName, widgetId) => {
    if (profileName !== null) {
      //ClickNTalk page
      WidgetService.getWidgetDtoByPersonalProfileName(
        profileName,
        this.doWhenWidgetDtoReceived,
        (response) => {
          // this.isServerConnected = false;
          this.handleErrors(response);
          if (utilsService.getIsPersonalPage()) {
            this.setNotificationPopUpData(
              'Seems there is no one here. Make sure the link is right.',
            );
          }
        },
      );
      this.setState({profileName});
    } else {
      //Widget
      WidgetService.getWidgetDtoByWidgetId(
        widgetId,
        this.doWhenWidgetDtoReceived,
        (response) => {
          // this.isServerConnected = false;
          this.handleErrors(response);
          if (utilsService.getIsPersonalPage()) {
            this.setNotificationPopUpData(
              'Seems there is no one here. Make sure the link is right.',
            );
          }
        },
      );
    }
  };

  sendMarketingInfoWidgetBeenUsed = (widgetDto) => {
    // return;
    if (
      !widgetDto.widgetBeenUsed && // send once only
      !utilsService.getIsPersonalPage() // widget only
    ) {
      const pageLocation = postMessageService.getLocation();
      const websiteUrl = pageLocation?.fullUrl;
      let data = {
        websiteUrl,
        widgetId: widgetDto.widgetId,
      };
      if (
        data.websiteUrl &&
        data.websiteUrl.toLowerCase().indexOf('consolto') === -1
      ) {
        this.setState({
          widgetInstalledMarketingParams: true,
          marketingParams: data,
        });
      }

      // used to send information that this widget has been used.
      // try {
      //   marketingParametersService.updateMarketingParameters(
      //     'PERSONAL',
      //     widgetDto.object.mentorDto.mentorOwnerId,
      //     {
      //       param:
      //         VIDABOO_CONSTANTS.MARKETING_EVENT_TYPES
      //           .USER_INSTALLED_PLUGIN_ON_WEBSITE,

      //       websiteUrl: postMessageService.getHomePage(),
      //       widgetId: widgetDto.widgetId,
      //     },
      //   );
      // } catch (error) {
      //   console.debug(error);
      // }
    }
  };
  preparePeerStatus = () => {
    const peers = Object.keys(this.state.widgetDto.usersControlPublicMap);
    const peerStatuses = {};
    peers.forEach((peerId) => {
      const peerStatus = {};
      peerStatus.availability = this.context.peersStatus[peerId];
      peerStatuses[peerId] = peerStatus;
    });
    return peerStatuses;
  };
  doWhenWidgetDtoReceived = ({widgetDto}) => {
    multiWidgetService.addDefaultValuesToWidgetDto(widgetDto);
    this.props.widgetContext.setWidgetDto(
      JSON.parse(JSON.stringify(widgetDto)),
    );

    // filter inactive mentors
    this.filterInActiveMentors(widgetDto);

    const shouldHandleTeamChat =
      !utilsService.getIsPersonalPage() &&
      !this.state.isDirectory &&
      [
        VIDABOO_CONSTANTS.WIDGET_INTERACTION_MODE.LIST_AND_CHAT,
        VIDABOO_CONSTANTS.WIDGET_INTERACTION_MODE.TEAM_WIDGET,
      ].includes(widgetDto.widgetAppCtrlDto.widgetInteractionMode);
    widgetDto.widgetAppCtrlDto.widgetPrivacyMode !==
      VIDABOO_CONSTANTS.WIDGET_PRIVACY_MODES.FULLY_PRIVATE;
    if (shouldHandleTeamChat) {
      this.handleTeamChatRoom(widgetDto);
    } else {
      if (utilsService.getIsInWidget()) {
        utilsService.removeTeamOneOnOneRoomInfo();
      }
      this.setState({widgetDto, inTeamChatScenario: false});
    }
    this.sendMarketingInfoWidgetBeenUsed(widgetDto);
    //todobr iharel: why were the below removed? Specifically registerPeerStatusCallback and sendMarketingInfoWidgetBeenUsed

    // if (widgetDto.widgetType === VIDABOO_CONSTANTS.WIDGET_ID_TYPE.ACCOUNT) {
    //   this.setState({
    //     widgetType: VIDABOO_CONSTANTS.WIDGET_ID_TYPE.ACCOUNT,
    //     widgetDto,
    //   });
    //   postMessageService.registerPeerStatusCallback(this.preparePeerStatus);
    // } else {
    //   this.sendMarketingInfoWidgetBeenUsed(widgetDto);
    //   this.setState({
    //     widgetType: VIDABOO_CONSTANTS.WIDGET_ID_TYPE.PERSONAL,
    //     widgetDto,
    //   });
    // }
  };

  filterInActiveMentors = (widgetDto) => {
    Object.keys(widgetDto.mentorsControlMapDto).forEach((mentorId) => {
      if (
        !widgetDto.mentorsControlMapDto[mentorId].extendedMentorDto.mentorDto
          .isActive
      ) {
        delete widgetDto.mentorsControlMapDto[mentorId];
      }
    });
  };

  handleTeamChatRoom = async (widgetDto) => {
    // if it is widget level chat then we need to create chat room on customer side
    const ownerObjectType = VIDABOO_CONSTANTS.CHAT_ROOM_OWNER_TYPE.TEAM_MENTOR;
    const ownerObjectId =
      multiWidgetService.getWidgetTeamMentorIds(widgetDto)[0];
    const guestUserIds = [this.context.getCurrentUser().userId];
    const chatRoomDto = await this.getCreateChatRoomByOwnerAndGuests(
      ownerObjectType,
      ownerObjectId,
      guestUserIds,
    );

    let lsTeamOneOnOneRoomInfo = utilsService.getTeamOneOnOneRoomInfo(
      widgetDto.widgetId,
    );
    if (
      lsTeamOneOnOneRoomInfo?.roomCreationInitiator ===
      VIDABOO_CONSTANTS.LOCAL_STORAGE_ROOM_INITIATOR.ACTION_CLICK
    ) {
      utilsService.removeTeamOneOnOneRoomInfo();
      lsTeamOneOnOneRoomInfo = null;
    }

    let lsOneOnOneRoomMentorId = lsTeamOneOnOneRoomInfo?.selectedMentorId;

    const shouldShowOneOnOneRoom = this.getShouldShowOneOnOneRoom(
      widgetDto,
      chatRoomDto,
      lsTeamOneOnOneRoomInfo,
    );
    if (shouldShowOneOnOneRoom) {
      // show one on one chat
      if (
        !lsOneOnOneRoomMentorId ||
        (chatRoomDto.taskOwnerMentorId &&
          lsOneOnOneRoomMentorId !== chatRoomDto.taskOwnerMentorId)
      ) {
        // update local storage roomInfo
        lsOneOnOneRoomMentorId = chatRoomDto.taskOwnerMentorId;
        const teamOneOnOneRoomInfo = {
          [widgetDto.widgetId]: {
            selectedMentorId: lsOneOnOneRoomMentorId,
          },
        };
        utilsService.saveTeamOneOnOneRoomInfo(teamOneOnOneRoomInfo);
      }

      this.setState({
        widgetDto,
        inTeamChatScenario: false,
        currentlyActiveMentorId: lsOneOnOneRoomMentorId,
      });
    } else {
      //show widget level chat
      utilsService.removeTeamOneOnOneRoomInfo();
      this.setState({
        widgetDto,
        inTeamChatScenario: true,
        currentlyActiveMentorId: null,
      });
    }
  };

  getShouldShowOneOnOneRoom = (
    widgetDto,
    chatRoomDto,
    lsTeamOneOnOneRoomInfo,
  ) => {
    if (
      widgetDto.widgetAppCtrlDto.widgetPrivacyMode ===
        VIDABOO_CONSTANTS.WIDGET_PRIVACY_MODES.FULLY_PRIVATE ||
      (widgetDto.widgetAppCtrlDto.widgetPrivacyMode ===
        VIDABOO_CONSTANTS.WIDGET_PRIVACY_MODES.HALF_PRIVATE &&
        chatRoomDto.taskOwnerMentorId)
    ) {
      return true;
    } else if (
      widgetDto.widgetAppCtrlDto.widgetPrivacyMode ===
        VIDABOO_CONSTANTS.WIDGET_PRIVACY_MODES.FULLY_SHARED &&
      lsTeamOneOnOneRoomInfo?.selectedMentorId
    ) {
      return true;
    } else if (
      widgetDto.widgetAppCtrlDto.widgetInteractionMode ===
        VIDABOO_CONSTANTS.WIDGET_INTERACTION_MODE.LIST_AND_CHAT &&
      !chatRoomDto.taskOwnerMentorId
    ) {
      // this will show the agent list + chat ui
      return true;
    } else {
      return false;
    }
  };

  getCreateChatRoomByOwnerAndGuests = (
    ownerObjectType,
    ownerObjectId,
    guestUserIds,
  ) => {
    return new Promise((resolve, reject) => {
      chatService.getCreateChatRoomByOwnerAndGuests(
        ownerObjectType,
        ownerObjectId,
        guestUserIds,
        (chatRoomDto) => {
          resolve(chatRoomDto);
        },
        (error) => {
          reject(error);
        },
      );
    });
  };

  handleTransitionToMentorRoom = (
    mentorId,
    mentorChatRoomId,
    isActionClickFlow,
  ) => {
    const exMentorDtoOfChatTransition =
      this.state.widgetDto.mentorsControlMapDto[mentorId]?.extendedMentorDto;
    if (exMentorDtoOfChatTransition) {
      const widgetId = this.state.widgetDto.widgetId;
      const lsTeamOneOnOneRoomInfo =
        utilsService.getTeamOneOnOneRoomInfo(widgetId);
      const showChatTransitionAnim = isActionClickFlow
        ? lsTeamOneOnOneRoomInfo.selectedMentorId === mentorId
          ? false
          : true
        : true;

      const teamOneOnOneRoomInfo = {
        [widgetId]: {
          roomCreationInitiator: isActionClickFlow
            ? VIDABOO_CONSTANTS.LOCAL_STORAGE_ROOM_INITIATOR.ACTION_CLICK
            : VIDABOO_CONSTANTS.LOCAL_STORAGE_ROOM_INITIATOR.WEBSOCKET,
          selectedMentorId: mentorId,
        },
      };
      utilsService.saveTeamOneOnOneRoomInfo(teamOneOnOneRoomInfo);

      if (showChatTransitionAnim) {
        this.props.widgetContext.startTransitionToMentorChatAnim(() => {
          this.setState({
            inTeamChatScenario: false,
            currentlyActiveMentorId: mentorId,
            exMentorDtoOfChatTransition,
          });
        });
      }
    } else {
      console.error('Trying to move to 1x1 mentor with invalid mentorId');
    }
  };

  handleTransitionToTeamChatRoom = async () => {
    if (this.state.inTeamChatScenario) return;
    this.props.widgetContext.startTransitionToTeamChatAnim(() => {
      utilsService.removeTeamOneOnOneRoomInfo();
      this.setState({
        inTeamChatScenario: true,
        currentlyActiveMentorId: null,
        exMentorDtoOfChatTransition: null,
      });
    });
  };

  moveOutOfTeamChat = (cb) => {
    this.setState(
      {inTeamChatScenario: false, currentlyActiveMentorId: null},
      () => {
        if (cb) cb();
      },
    );
  };

  setIsAutomatedCallHandled = (isAutomatedCallHandled) => {
    this.setState({isAutomatedCallHandled});
  };

  openConsolto = () => {
    window.open(
      VIDABOO_CONSTANTS.HomePage +
        '?utm_source=' +
        VIDABOO_CONSTANTS.UTM_SOURCES.CONSOLTO +
        '&utm_medium=' +
        VIDABOO_CONSTANTS.UTM_MEDIUMS.PERSONAL_PAGE +
        '&utm_campaign=' +
        VIDABOO_CONSTANTS.UTM_CAMPAIGNS.PERSONAL_PAGE_BTN,
      '_blank',
    );
  };

  setNotificationPopUpData = (notificationTxt) => {
    this.setState({
      showNotificationPopUp: true,
      notificationTxt,
      closeBtnFunc: this.openConsolto,
    });
  };

  handleErrors = (error) => {
    console.error('Error: ', error.data?.errorMessage);
  };

  render() {
    const {
      inTeamChatScenario,
      widgetInstalledMarketingParams,
      marketingParams,
      exMentorDtoOfChatTransition,
      widgetDto,
    } = this.state;
    const showTransitionToTeamChatAnim =
      this.props.widgetContext.chatTransitionAnimationType ===
        VIDABOO_CONSTANTS.TRANSITION_ANIMATIONS_TYPES.TRANSITION_TO_TEAM_CHAT ||
      this.props.widgetContext.chatTransitionAnimationType ===
        VIDABOO_CONSTANTS.TRANSITION_ANIMATIONS_TYPES
          .TRANSITION_TO_TEAM_CHAT_CLOSE;
    const showTransitionToMentorChatCloseAnim =
      this.props.widgetContext.chatTransitionAnimationType ===
      VIDABOO_CONSTANTS.TRANSITION_ANIMATIONS_TYPES
        .TRANSITION_TO_MENTOR_CHAT_CLOSE;
    const showTransitionToTeamChatCloseAnim =
      this.props.widgetContext.chatTransitionAnimationType ===
      VIDABOO_CONSTANTS.TRANSITION_ANIMATIONS_TYPES
        .TRANSITION_TO_TEAM_CHAT_CLOSE;

    const isInMobile = utilsService.isMobileDevice(); //todomcss : ok
    const canMoveToTeamChat =
      utilsService.getIsInWidget() &&
      !!utilsService.getTeamOneOnOneRoomInfo(widgetDto?.widgetId)
        ?.selectedMentorId;

    return (
      <>
        {/* {this.state.widgetType &&
          (this.state.widgetType ===
          VIDABOO_CONSTANTS.WIDGET_ID_TYPE.PERSONAL ? (
            <SingleExpertWidget
              widgetDto={this.state.widgetDto}
              extendedMentorDto={
                Object.values(this.state.widgetDto.mentorsControlMapDto)[0]
                  .extendedMentorDto
              }
              startValueFromQuery={this.state.startValueFromQuery}
              bfi={this.state.bfi}
            />
          ) : ( */}
        <WindowResizerComponent />
        {this.state.showNotificationPopUp && (
          <NotificationComponent
            closeBtnTxt={'Ok'}
            notificationTxt={this.state.notificationTxt}
            closeBtnFunc={this.state.closeBtnFunc}
          />
        )}
        {this.props.widgetContext.chatTransitionAnimationType !==
          VIDABOO_CONSTANTS.TRANSITION_ANIMATIONS_TYPES.NO_ANIMATION &&
          postMessageService.getWidgetSize() !==
            VIDABOO_CONSTANTS.WIDGET_SIZE.WIDGET_CLOSED && (
            <HandOffComponent
              showCloseAnim={
                showTransitionToMentorChatCloseAnim ||
                showTransitionToTeamChatCloseAnim
              }
              extendedMentorDto={exMentorDtoOfChatTransition}
              handOffComponentType={
                showTransitionToTeamChatAnim
                  ? VIDABOO_CONSTANTS.HANDOFF_COMPONENT_TYPES.TEAM_CHAT
                  : VIDABOO_CONSTANTS.HANDOFF_COMPONENT_TYPES.ONE_ON_ONE_CHAT
              }
              handOffText={
                showTransitionToTeamChatAnim
                  ? 'Transferring to team chat'
                  : 'Transferring to one-on-one conversation'
              }
              widgetDto={widgetDto}
            />
          )}

        {this.state.widgetDto && this.state.inTeamChatScenario !== null && (
          <>
            <PreloadLazyComponents
              componentKeys={[
                VIDABOO_CONSTANTS.LAZY_LOADED_COMPONENTS.EMOJI_MART_REACT,
                VIDABOO_CONSTANTS.LAZY_LOADED_COMPONENTS.EMOJI_MART_DATA,
                VIDABOO_CONSTANTS.LAZY_LOADED_COMPONENTS.MOMENT,
                VIDABOO_CONSTANTS.LAZY_LOADED_COMPONENTS.OT_VIDEO_COMPONENT,
              ]}
            />
            <MultiExpertWidget
              bfi={this.state.bfi}
              canMoveToTeamChat={canMoveToTeamChat}
              isDirectory={this.state.isDirectory}
              isAutomatedCallHandled={this.state.isAutomatedCallHandled}
              inTeamChatScenario={inTeamChatScenario}
              currentlyActiveMentorId={this.state.currentlyActiveMentorId}
              profileName={this.state.profileName}
              isChatTransitionFlowRunning={
                this.props.widgetContext.chatTransitionAnimationType !==
                VIDABOO_CONSTANTS.TRANSITION_ANIMATIONS_TYPES.NO_ANIMATION
              }
              startValueFromQuery={this.state.startValueFromQuery}
              widgetDto={this.state.widgetDto}
              handleTransitionToMentorRoom={this.handleTransitionToMentorRoom}
              handleTransitionToTeamChatRoom={
                this.handleTransitionToTeamChatRoom
              }
              setIsAutomatedCallHandled={this.setIsAutomatedCallHandled}
              moveOutOfTeamChat={this.moveOutOfTeamChat}
              setNotificationPopUpData={this.setNotificationPopUpData}
            />
          </>
        )}
        {/* ))}  */}
        {!isInMobile && widgetInstalledMarketingParams && (
          <UpdateMarketingParamsComponent
            params={marketingParams}
            action={
              VIDABOO_CONSTANTS.MARKETING_EVENT_TYPES
                .USER_INSTALLED_PLUGIN_ON_WEBSITE
            }
          />
        )}
      </>
    );
  }
}
WidgetContainerComponent.contextType = AppContext;
export default withRouter(withWidgetContext(WidgetContainerComponent));
